
























import { Component, Vue } from "vue-property-decorator";
import { UnlockViewModel } from "@/game/ViewModels/unlock";
import { UnlockState } from "@/game/Models/unlock";
import GameConfig from "@/game/game-config";

@Component
export default class Unlocks extends Vue {
    get unlocks(): UnlockViewModel[] {
        return this.$store.state.unlocks.filter((u: UnlockState) => u.unlocked && !u.purchased).map((u: UnlockState) => new UnlockViewModel(u, GameConfig.GetUnlock(u.id)));
    }

    public canBuy(id: string): boolean {
        const unlock = GameConfig.GetUnlock(id);
        return this.$store.state.declaraties >= unlock.Price;
    }

    public purchase(id: string): void {
        this.$store.commit("purchaseUnlock", id);
    }
}
